import React from 'react';
import { Wrench } from 'lucide-react';

// If a screen ever crashes, show a calm maintenance message instead of a blank or red error page.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // kept in the browser console for the developers; never shown to the user
    console.warn('Screen error caught:', error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    // moving to another page gives the app a fresh start
    if (this.state.failed && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ failed: false });
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="min-h-[70vh] flex items-center justify-center px-4 py-12" data-testid="maintenance-page">
        <div className="clay-card max-w-lg w-full p-8 text-center">
          <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
            <Wrench className="w-8 h-8 text-amber-600" />
          </div>
          <h1 className="text-2xl font-outfit font-black text-slate-900 mb-2">We are doing a little maintenance</h1>
          <p className="font-figtree text-slate-600 mb-6">
            This part of Altanon Learn is not available right now. Please try again in a few minutes. Your progress and data are safe.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <button className="clay-button-primary px-5 py-2.5" onClick={() => window.location.reload()}>Try again</button>
            <a href="/" className="clay-button-secondary px-5 py-2.5 inline-block">Go to home page</a>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
